import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { axiosInstance } from "../axiosInstance";

// import { toastSuccess, toastError } from "src/components/ToastUtils";

// POST: Set custom availability
export const useSetCustomAvailability = (providerId) => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (data) =>
      axiosInstance.post(`/providers/${providerId}/available-recurrences?duration=120`, data),
    onSuccess: (response) => {
      const success = response?.data?.success;
      if (success) {
        // toastSuccess(
        //   "Your availability has been saved and is now visible for booking sessions.",
        //   "Custom Data Set Successfully.",
        //   true
        // );
        queryClient.invalidateQueries({
          queryKey: ["getCustomAvailability"],
        });
      }
      console.log(response);
    },
    onError: (error) => {
      //   toastError(error);
      console.log(error);
    },
  });
  return {
    BookSession: mutation.mutate,
    isPending: mutation.isPending,
  };
};

// GET: Fetch custom availability
export const useGetCustomAvailability = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["getCustomAvailability"],
    queryFn: () =>
      axiosInstance
        .get("/providers/availability/custom")
        .then((res) => res.data),
  });
  return {
    getCustomAvailabilityData: data,
    getCustomAvailabilityIsLoading: isLoading,
    getCustomAvailabilityError: error,
  };
};

// GET: Fetch all availabilities (example endpoint)
export const useGetAllAvailabilities = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["getAllAvailabilities"],
    queryFn: () =>
      axiosInstance.get("/providers/availability").then((res) => res.data),
  });
  return {
    getAllAvailabilitiesData: data,
    getAllAvailabilitiesIsLoading: isLoading,
    getAllAvailabilitiesError: error,
  };
};